import { useRegisterSW } from "virtual:pwa-register/react";
import { Fragment, ReactElement, useState } from "react";
import { useInterval } from "ahooks";
import { Dialog, Transition } from "@headlessui/react";

export default function ReloadPrompt(): ReactElement {
  const [swUrl, setSwUrl] = useState<string>();
  const [r, setR] = useState<ServiceWorkerRegistration | undefined>();

  useInterval(async () => {
    if (!swUrl || !r) {
      return;
    }

    if (!(!r.installing && navigator)) return;

    if ("connection" in navigator && !navigator.onLine) return;

    const resp = await fetch(swUrl, {
      cache: "no-store",
      headers: {
        cache: "no-store",
        "cache-control": "no-cache",
      },
    });

    if (resp?.status === 200) await r.update();
  }, 1000 * 60);

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      console.debug(`Service Worker at: ${swUrl}`);
      console.debug("SW Registered: " + r);
      setSwUrl(swUrl);
      setR(r);
    },
    onRegisterError(error) {
      console.log("SW registration error", error);
    },
  });

  const close = () => {
    setNeedRefresh(false);
  };

  return (
    <Transition appear show={needRefresh} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={close}>
        <div className="fixed inset-0 w-full flex items-end md:flex-row-reverse	 p-4">
          <Transition.Child
            as={Fragment}
            enter="transition ease-out duration-300 transform"
            enterFrom="translate-y-full"
            enterTo="translate-y-0"
            leave="transition ease-in duration-200 transform"
            leaveFrom="translate-x-0 translate-y-0"
            leaveTo="translate-y-full"
          >
            <Dialog.Panel className="w-full md:w-1/4 transform overflow-hidden rounded-2xl bg-white p-4 text-left align-middle shadow-xl transition-all">
              <Dialog.Title
                as="h3"
                className="text-lg font-medium leading-6 text-gray-900"
              >
                🎉新版本已经准备好
              </Dialog.Title>
              <div className="mt-1">
                <p className="text-sm text-gray-500">重载页面以获取最新版本</p>
              </div>

              <div className="mt-2 flex gap-2 flex-row-reverse">
                <button
                  type="button"
                  className="inline-flex justify-center rounded-md border border-transparent bg-default-100 px-2 py-1 text-sm font-medium text-default-500 hover:bg-default-200 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-default-500 focus-visible:ring-offset-2"
                  onClick={() => updateServiceWorker(true)}
                >
                  重载
                </button>
                <button
                  type="button"
                  className="inline-flex justify-center rounded-md border border-transparent bg-default-100 px-2 py-1 text-sm font-medium text-default-500 hover:bg-default-200 hover:text-whit focus:outline-none focus-visible:ring-2 focus-visible:ring-default-500 focus-visible:ring-offset-2"
                  onClick={close}
                >
                  取消
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
